module.exports = __webpack_public_path__ + "static/img/guidance.a077360b.gif";